<script>
    import { onMount } from 'svelte';
    import { getContext } from 'svelte';
    import { store } from "../../store.js";
    import emailjs from "emailjs-com";
    import Section from "../Common/Section.svelte";
    import LinkButton2 from "../Common/LinkButton2.svelte";
    import Typewriter from "svelte-typewriter";

    import PartnersCarousel from "../Common/PartnersCarousel.svelte";
    import BrandCarousel from "../Common/BrandCarousel.svelte";
    import Roadmap from "../Common/Roadmap.svelte";
    import Contact from "../Common/Contact.svelte";
    import sections from "./sections";
    import Popup from './Popup.svelte';

    let brandCarousel, partnersCarousel;
    let emailSending = false;

    const { open } = getContext('simple-modal');
    const showSurprise = () => open(Popup, { message: "It's a modal!" });

    onMount(()=>{
        showSurprise();
    })
    
</script>
<section style:position={"relative"}>
    <Section
        name="home1"
        styles={sections[$store.type][$store.locale]['home1'] || null}
    >        
        <!-- <Typewriter cascade interval={50} cursor={false}>
            <h1 class="slogan font-koho">Beyond Metaverse,</h1>
            <h1 class="slogan font-koho d-inline">Connect Revolution</h1>
            <h1 class="slogan font-koho blink d-inline">_</h1>
        </Typewriter>   -->
        <Typewriter cascade interval={50} cursor={false}>
            {#if $store.locale === 'en'}      
            <div class="text-center">
                <h1 class="slogan font-koho">Connecting virtual and reality,</h1>
                <h1 class="slogan font-koho d-inline">Konnect</h1>
                <h1 class="slogan font-koho blink d-inline">_</h1>
            </div>
            {:else if $store.locale === 'kr'} 
            <div class="text-center">
                <h1 class="slogan font-koho">가상과 현실을 잇-다,</h1>
                <h1 class="slogan font-koho d-inline">Konnect</h1>
                <h1 class="slogan font-koho blink d-inline">_</h1>
            </div>
            {:else if $store.locale === 'vn'} 
            <div class="text-center">
                <h1 class="slogan font-koho">Connecting virtual and reality,</h1>
                <h1 class="slogan font-koho d-inline">Konnect</h1>
                <h1 class="slogan font-koho blink d-inline">_</h1>
            </div>
            {/if}
        </Typewriter>  
    </Section>

    <Section
        name="home2"
        styles={sections[$store.type][$store.locale]['home2'] || null}

    >        
        {#if $store.locale === 'en'}
            <div class="sub-slogan">
                Konnect is a Web3 lifestyle membership project that combines blockchain technology with NFT.
                <br>
                Konnect connects virtual reality and the real economy more transparent and faster than anyone else.
            </div>        
        {:else if $store.locale === 'kr'}
            <div class="sub-slogan">
                Konnect는 블록체인 기술을 NFT를 접목한 웹3 라이프스타일 멤버십 프로젝트입니다.
                <br>
                가상현실과 실물경제를 누구보다 투명하고 빠르게 이어갑니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="sub-slogan">
                Konnect is a Web3 lifestyle membership project that combines blockchain technology with NFT.
                <br>
                Konnect connects virtual reality and the real economy more transparent and faster than anyone else.
            </div>  
        {/if} 
    </Section>

    <Section
        name="home3"
        styles={sections[$store.type][$store.locale]['home3'] || null}

    >
        <div class="slogan2">
            Konnect makes<br>
            <span class="accent">REVOLUTION</span>
            <br>
            with you
        </div>
    </Section>

    <Section
        name="home4"
        styles={sections[$store.type][$store.locale]['home4'] || null}

    >
        <Typewriter cascade loop={true} interval={50} cursor={false}>
            <h1 class="slogan font-koho">KONNECT TOKEN</h1>
        </Typewriter>
    </Section>

    <Section
        name="home5"
        styles={sections[$store.type][$store.locale]['home5'] || null}

    >
        
        {#if $store.locale === 'en'}
            <div class="slogan3">
                "Connects virtual and reality"
            </div>        
        {:else if $store.locale === 'kr'}
            <div class="slogan3">
                "가상과 현실을 잇-다"
            </div>
        {:else if $store.locale === 'vn'}
            <div class="slogan3">
                "Kết nối thế giới ảo và thế giới thực"
            </div>
        {/if} 
    </Section>

    <Section
        name="home6"
        styles={sections[$store.type][$store.locale]['home6'] || null}

    >        
        {#if $store.locale === 'en'}
            <div class="about-title">
                Tickets to meet the new world
            </div>       
        {:else if $store.locale === 'kr'}
            <div class="about-title">
                새로운 세상을 만나는 티켓
            </div>
        {:else if $store.locale === 'vn'}
            <div class="about-title">
                Tấm vé đến với thế giới mới
            </div>
        {/if} 
    </Section>

    <Section
        name="home7"
        styles={sections[$store.type][$store.locale]['home7'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="about-desc">
                KCT is a common membership token in Konnect World.
                KCT can be utilized for more membership benefits.
                You can subscribe to the membership service by depositing KCT, and raise your membership tier.
                Starting with the Ethereum platform, KCT plans to expand support to multiple platforms
            </div>      
        {:else if $store.locale === 'kr'}
            <div class="about-desc">
                KCT는 Konnect World에서 통용되는 멤버십 토큰입니다. 
                사용자들은 더 큰 혜택을 위해 KCT를 사용할 수 있습니다. 
                KCT를 예치하여 멤버십 서비스에 가입하고, 멤버십 등급을 올릴 수 있습니다. 
                KCT는 이더리움 플랫폼을 시작으로 다중 플랫폼으로 지원을 확장할 계획입니다
            </div>
        {:else if $store.locale === 'vn'}
            <div class="about-desc">
                Mã thông báo KCT là một yếu tố thành viên được sử dụng trong Konnect World.
                Bạn có thể tăng cấp độ thành viên của mình bằng cách tích lũy KCT Token.
                Bắt đầu với nền tảng Ethereum, Konnect có kế hoạch mở rộng hỗ trợ cho nhiều nền tảng khác nhau.
            </div>
        {/if}        
    </Section>

    <Section
        name="home8"
        styles={sections[$store.type][$store.locale]['home8'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 550, height: 100 }
                : $store.locale === "kr"
                ? { width: 550, height: 100 }
                : $store.locale === "vn"
                ? { width: 550, height: 100 }
                : null}
            hide={false}
            cursor={true}
            typewriter={false}
            logo={true}
            href="/kct#konnect"
            text={
                $store.locale === 'en' ? "About KCT" 
                    : $store.locale === 'kr' ? "KCT 더 알아보기"
                    : $store.locale === 'vn' ? "Tìm hiểu thêm về KCT" : "About KCT"}
        />
    </Section>

    <Section
        name="home9"
        styles={sections[$store.type][$store.locale]['home9'] || null}
    >
        <Typewriter cascade loop={true} interval={100} cursor={false}>
            <h1 class="slogan font-koho">MEMBERSHIP</h1>
        </Typewriter>
    </Section>

    <Section
        name="home10"
        styles={sections[$store.type][$store.locale]['home10'] || null}
    >        
        {#if $store.locale === 'en'}
            <div class="common-title">
                Membership benefits with<br>KCT Membership or NFT
            </div>     
        {:else if $store.locale === 'kr'}
            <div class="common-title">
                KCT 멤버십 또는 NFT로<br>누리는 티어 혜택
            </div>
        {:else if $store.locale === 'vn'}
            <div class="common-title">
                Quyền lợi của người <br>sở hữu KCT Token và Konnect NFT
            </div>
        {/if} 
    </Section>

    <Section
        name="home11"
        styles={sections[$store.type][$store.locale]['home11'] || null}
    >        
        {#if $store.locale === 'en'}
            <div class="common-desc membership-desc">
                KCT users are not just buyers but members of the Konnect World ecosystem. Konnect World is a platform that grows with users by providing benefits and rewards through membership services. Konnect aims for the fastest and more transparent Web3 ecosystem of physical goods and services through blockchain and virtual assets.
            </div>   
        {:else if $store.locale === 'kr'}
            <div class="common-desc membership-desc">
                KCT 사용자들은 단순한 구매자가 아닌 Konnect World 생태계의 구성원입니다. Konnect World는 사용자들이 멤버십 서비스를 통해 여러 보상과 혜택을 얻으며 함께 성장하는 플랫폼입니다. Konnect는 블록체인과 가상자산을 통해 실물 재화 및 서비스를 가장 빠르고 투명하게 연결하는 웹3 생태계를 지향합니다. 
            </div>
        {:else if $store.locale === 'vn'}
            <div class="common-desc membership-desc">
                Bạn trở thành một phần của hệ sinh thái Konnect sau khi đăng ký thành công 
                membership, có thể hoạt động trên nền tảng, nhận được nhiều ưu đãi và quyền 
                lợi để cùng nhau phát triển. Konnect áp dụng tính năng hàng hóa thật và dịch
                vụ tài sản kỹ thuật số vào KCT Token thông qua công nghệ blockchain rồi 
                cung cấp cho các thành viên.
            </div>
        {/if} 
    </Section>

    <Section
        name="home12"
        styles={sections[$store.type][$store.locale]['home12'] || null}
    >
        <div class="list-title">
            # 01
        </div>
        
        {#if $store.locale === 'en'}
            <div class="list-item font-roboto">
                Konnect Booking System (Air, Accomodation, etc.)
                Discounts based on membership and tier ratings
                in the Konnect e-commerce.
            </div>   
        {:else if $store.locale === 'kr'}
            <div class="list-item font-roboto">
                Konnect 부킹 시스템 (항공, 숙박 등) 
                Konnect 이커머스(명품 쇼핑 등) 이용시 
                멤버십과 티어 등급에 따른 할인 혜택
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item font-roboto">
                Nhận được giảm giá và ưu đãi khi sử dụng dịch vụ 
                E-commerce (mua sắm, hàng không, khách sạn, v.v.) 
                tùy theo từng cấp độ thành viên
            </div>
        {/if} 
    </Section>

    <Section
        name="home13"
        styles={sections[$store.type][$store.locale]['home13'] || null}
    >
        <div class="list-title">
            # 02
        </div>
        {#if $store.locale === 'en'}
            <div class="list-item font-roboto">
                Discounts according to membership tier
                in the NFT Marketplace(Konnect World)
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item font-roboto">
                NFT Marketplace(Konnect World) 사용시 
                멤버십 등급에 따른 할인 혜택
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item font-roboto">
                Được giảm giá và ưu đãi tùy theo từng mức 
                độ thành viên trong NFT Marketplace
            </div>
        {/if} 
    </Section>

    <Section
        name="home14"
        styles={sections[$store.type][$store.locale]['home14'] || null}
    >
        <div class="list-title">
            # 03
        </div>
        
        {#if $store.locale === 'en'}
            <div class="list-item font-roboto">
                Membership and tier level
                according to KCT deposit
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item font-roboto">
                KCT 예치에 따른 멤버십과 
                티어 등급 부여 
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item font-roboto">
                Phát hành thẻ vật lý có thể dùng để 
                hoàn tiền nếu tích lũy token trong thời gian quy định
            </div>
        {/if} 
    </Section>

    <Section
        name="home15"
        styles={sections[$store.type][$store.locale]['home15'] || null}
    >
        <div class="list-title">
            # 04
        </div>
        {#if $store.locale === 'en'}
            <div class="list-item font-roboto">
                Limited NFT purchase and participation
                in minting through mystery boxes
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item font-roboto">
                한정판 NFT 구매와 미스터리 
                박스를 통한 민팅 참여
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item font-roboto">
                Có cơ hội mua NFT và Mystery box{'\n'}bản giới hạn
            </div>
        {/if}
    </Section>
    
    <Section
        name="home16"
        styles={sections[$store.type][$store.locale]['home16'] || null}
    >
        <div class="list-title">
            # 05
        </div>
        {#if $store.locale === 'en'}
            <div class="list-item font-roboto">
                Rewards according to KCT deposit
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item font-roboto">
                KCT 예치 보상과 혜택
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item font-roboto">
                Lợi ích và ưu đãi tương ứng với mỗi cấp 
                độ tùy theo số lượng KCT mà bạn tích lũy
            </div>
        {/if}
    </Section>

    <Section
        name="home17"
        styles={sections[$store.type][$store.locale]['home17'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 800, height: 100 }
                : $store.locale === "kr"
                ? { width: 800, height: 100 }
                : $store.locale === "vn"
                ? { width: 800, height: 100 }
                : null}
            hide={false}
            href="/kct#membership"
            text= {
                $store.locale === 'en' ? "Learn more about MEMBERSHIP" 
                : $store.locale === 'kr' ? "멤버십 더 알아보기"
                : $store.locale === 'vn' ? "Tìm hiểu thêm về Membership" : "Learn more about MEMBERSHIP"
            }
            cursor={true}
            typewriter={false}
            logo={true}
        />
    </Section>

    <Section
        name="home18"
        styles={sections[$store.type][$store.locale]['home18'] || null}
    >
        <Typewriter cascade loop={true} interval={100} cursor={false}>
            <h1 class="slogan font-koho">ECOSYSTEM</h1>
        </Typewriter>
    </Section>

    <Section
        name="home19"
        styles={sections[$store.type][$store.locale]['home19'] || null}
    >
        
        {#if $store.locale === 'en'}
            <div class="common-title">
                Infrastructure of <span class="highlight">'13.4 billion USD'</span> in sales already secured
            </div>
        {:else if $store.locale === 'kr'}
            <div class="common-title">
                이미 확보된 Konnect 실물경제 인프라, <span class="highlight">'6조원'</span>
            </div>
        {:else if $store.locale === 'vn'}
            <div class="common-title">
                Hạ tầng cơ sở thực tế của Konnect là <span class="highlight">'13,4 tỉ USD'</span> (6 nghìn tỉ won)
            </div>
        {/if}
    </Section>

    <Section
        name="home20"
        styles={sections[$store.type][$store.locale]['home20'] || null}
    >        
        {#if $store.locale === 'en'}
            <div class="common-desc">
                <span class="title">'We do not want risky adventures'</span>
                Konnect bases on the scale of '13.4 billion USD' real economic infrastructure that has already been secured.
                Konnect has combined KCT tokens with the advantages of blockchain to a stable real economy.
                Konnect can build a digital asset ecosystem based on the real economy with more stability and velocity than any other competitor.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="common-desc">
                <span class="title">'우리는 위험한 모험을 하지 않습니다'</span>
                Konnect는 이미 확보한 '6조원' 규모의 실물 경제 인프라를 기반으로 두고 있습니다. 
                안정적인 실물 경제에 블록체인의 장점을 적용한 KCT 토큰을 결합합니다. 
                Konnect는 누구보다 안정적이고 신속하게 실물경제 기반의 디지털자산 생태계 구축이 가능합니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="common-desc">
                <span class="title">'Chúng tôi không thực hiện những cuộc phiêu lưu mạo hiểm'</span>{'\n'}Konnect đã có sẵn nền tảng cơ sở hạ tầng nền kinh tế thật trị giá 6 nghìn tỉ won. Konnect kết hợp KCT Token được áp dụng ưu điểm của blockchain với nền kinh tế thật ổn định. Konnect có thể xây dựng một hệ sinh thái tiền ảo dựa trên nền kinh tế thật một cách ổn định và nhanh chóng hơn bất kỳ ai khác.
            </div>
        {/if}
    </Section>

    <Section
        name="home21"
        styles={sections[$store.type][$store.locale]['home21'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="membership-title">Target Market Annual Sales</div>
            <div class="membership-item">$13.4B+</div>
        {:else if $store.locale === 'kr'}
            <div class="membership-title">타겟시장의 연매출 규모</div>
            <div class="membership-item">6조원+</div>
        {:else if $store.locale === 'vn'}
            <div class="membership-title">Doanh số hàng năm của thị trường target</div>
            <div class="membership-item">6 nghìn tỷ+</div>
        {/if}
    </Section>

    <Section
        name="home22"
        styles={sections[$store.type][$store.locale]['home22'] || null}
    >        
        {#if $store.locale === 'en'}
            <div class="membership-title">User</div>
            <div class="membership-item">B2C 3M+</div>
            <div class="membership-item">B2B 200K+</div>
        {:else if $store.locale === 'kr'}
            <div class="membership-title">사용자</div>
            <div class="membership-item">B2C 3M+</div>
            <div class="membership-item">B2B 200K+</div>
        {:else if $store.locale === 'vn'}
            <div class="membership-title">Người dùng</div>
            <div class="membership-item">Doanh nghiệp 3M+</div>
            <div class="membership-item">Cá nhân 200K+</div>
        {/if}
    </Section>

    <Section
        name="home23"
        styles={sections[$store.type][$store.locale]['home23'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="membership-title">Country</div>
            <div class="membership-item">15+</div>
        {:else if $store.locale === 'kr'}
            <div class="membership-title">나라</div>
            <div class="membership-item">15+</div>
        {:else if $store.locale === 'vn'}
            <div class="membership-title">Quốc gia</div>
            <div class="membership-item">15+</div>
        {/if}
    </Section>

    <Section
        name="home24"
        styles={sections[$store.type][$store.locale]['home24'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="membership-title">Partner</div>
            <div class="membership-item">50+</div>
        {:else if $store.locale === 'kr'}
            <div class="membership-title">파트너</div>
            <div class="membership-item">50+</div>
        {:else if $store.locale === 'vn'}
            <div class="membership-title">Đối tác</div>
            <div class="membership-item">50+</div>
        {/if}
    </Section>

    <Section
        name="home25"
        styles={sections[$store.type][$store.locale]['home25'] || null}
    >

        {#if $store.locale === 'en'}
            <div class="membership-title">Goods</div>
            <div class="membership-item">60K+</div>
        {:else if $store.locale === 'kr'}
            <div class="membership-title">상품</div>
            <div class="membership-item">60K+</div>
        {:else if $store.locale === 'vn'}
            <div class="membership-title">Số lượng sản phẩm</div>
            <div class="membership-item">60K+</div>
        {/if}
    </Section>
    <Section
        name="home26"
        styles={sections[$store.type][$store.locale]['home26'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 800, height: 100 }
                : $store.locale === "kr"
                ? { width: 800, height: 100 }
                : $store.locale === "vn"
                ? { width: 800, height: 100 }
                : null}
            hide={false}
            href="/konnect#ecosystem"
            text= {
                $store.locale === 'en' 
                    ? "Discover the Konnect Ecosystem" 
                : $store.locale === 'kr' 
                    ? "Konnect 생태계 더 알아보기"
                : $store.locale === 'vn'
                    ? "Tìm hiểu thêm về hệ sinh thái Konnect": "Discover the Konnect Ecosystem"}
            cursor={true}
            typewriter={false}
            logo={true}
        />
    </Section>

    <Section
        name="home27"
        styles={sections[$store.type][$store.locale]['home27'] || null}
    >
        <Typewriter cascade loop={true} interval={50} cursor={false}>
            <h1 class="slogan font-koho text-white">KONNECT STORY</h1>
        </Typewriter>
    </Section>

    <Section
        name="home28"
        styles={sections[$store.type][$store.locale]['home28'] || null}
    >        
        {#if $store.locale === 'en'}
            <div class="common-desc text-white">
                Konnect Story is based on the worldview of Konnect World. Konnect World, a separate new world from reality, is implemented in metaverse.
                Meet the story of Konnect, which depicts virtuality and reality on two Earths at the same time, but in a different parallel universe :)
            </div>
        {:else if $store.locale === 'kr'}
            <div class="common-desc text-white">
                Konnect Story는 Konnect World 세계관의 이야기입니다. 현실과 또다른 세계인 Konnect World가 메타버스로 구현됩니다.
                같은 시간, 하지만 다른 평행 우주에 존재하는 두 개의 지구에서 가상과 현실을 그려낸 Konnect 스토리를 만나보세요 :)
            </div>
        {:else if $store.locale === 'vn'}
            <div class="common-desc text-white">
                Konnect World là một thế giới khác với thực tế được thể hiện dưới dạng metaverse. 
                Konnect Story kể về hai trái đất tồn tại trong những không gian khác nhau nhưng cùng một thời điểm, pha trộn giữa thực và ảo. 
            </div>
        {/if}
    </Section>

    <Section
        name="home29"
        styles={sections[$store.type][$store.locale]['home29'] || null}
    >
        
        {#if $store.locale === 'en'}
            <div class="story-title text-white">
                # 01. Konnect World
            </div>
            <div class="story-item text-white">
                There are multiple Earths seperated by different dimensions and parallel universes. Among them, Konnect is ruled by the Duman species that has managed to create a civilization far more advanced than the earth we know today.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="story-title text-white">
                # 01. 커넥트 월드
            </div>
            <div class="story-item text-white">
                "평행우주 안에 있는 수많은 지구들, 그 중의 하나인 Konnect는 우리의 지구보다 훨씬 고도화된 문명을 만들어 낸 DUMAN 종이 살고 있었다. 그들은 빅뱅에너지를 가진 Konnect라는 물질을 이용하여 에너지를 무한대로 쓸 수 있는 기술을 가지고 있었다"
            </div>
        {:else if $store.locale === 'vn'}
            <div class="story-title text-white">
                # 01. Konnect World
            </div>
            <div class="story-item text-white">                
                Nhiều trái đất được kết nối bằng vũ trụ song song. Vũ trụ có nền văn minh tiên tiến nhất trong số đó chính là Konnect World, nơi loài DUMAN cai trị. Họ chế tạo ra Konnect, vật liệu được cô đặc từ năng lượng của vụ nổ lớn và có khả năng mở rộng các thiên hà, cho phép họ điều khiển nguồn năng lượng vô hạn theo ý muốn.
            </div>
        {/if}

    </Section>

    <Section
        name="home30"
        styles={sections[$store.type][$store.locale]['home30'] || null}
    >
        
        {#if $store.locale === 'en'}
            <div class="story-title text-white">
                # 02. Birth of Konnect
            </div>
            <div class="story-item text-white">
                In 1883, meteors made of Konnect fell to the earth. Since the impace, the two earth which had Konnect and not in parallel universe after that, the one with metoer start to experience significant environment change due to Konnect's bigbang energy
            </div>
        {:else if $store.locale === 'kr'}
            <div class="story-title text-white">
                # 02. Birth of Konnect
            </div>
            <div class="story-item text-white">
                1883년 지구, Konnect로 이루어진 운석이 떨어진다. 이 충돌을 기점으로 평행 우주 내에서는 Konnect 운석이 떨어진 지구와 아닌 지구, 둘로 나뉘게 된다. 이후 운석이 떨어진 지구에서는 빅뱅에너지를 가진 Konnect의 영향으로 급격한 환경의 변화가 시작하였다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="story-title text-white">
                # 02. Sự ra đời của Konnect
            </div>
            <div class="story-item text-white">
                Năm 1883. Một thiên thạch được tạo ra từ Konnect rơi xuống Trái đất qua một lỗ sâu kết nối với Konnect World. Sau vụ va chạm thiên thạch, Trái đất được chia thành những lục địa bị ảnh hưởng bởi thiên thạch Konnect và những lục địa không bị ảnh hưởng. Trong lục địa bị ảnh hưởng bởi Konnect, năng lượng chứa trong thiên thạch bắt đầu thay đổi hoàn toàn Trái đất.
            </div>
        {/if}
    </Section>

    <Section
        name="home31"
        styles={sections[$store.type][$store.locale]['home31'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 800, height: 100 }
                : $store.locale === "kr"
                ? { width: 800, height: 100 }
                : $store.locale === "vn"
                ? { width: 800, height: 100 }
                : null}
            hide={false}
            href="/nft#story"    
            text= {
                $store.locale === 'en' 
                ? "Read more Konnect World Stories"
                 : $store.locale === 'kr' 
                 ? "Konnect 스토리 더 보기"
                 : $store.locale === 'vn' ? "Đọc thêm về câu chuyện của Konnect World" : "Read more Konnect World Stories"}     
            cursor={true}
            typewriter={false}
            logo={true}
        />
    </Section>

    <Section
        name="home32"
        styles={sections[$store.type][$store.locale]['home32'] || null}
    >
        <Typewriter cascade loop={true} interval={100} cursor={false}>
            {#if $store.locale === 'en'}
                <h1 class="question font-koho">Do you own any NFTs?</h1>
            {:else if $store.locale === 'kr'}
                <h1 class="question font-koho">너는 어떤 NFT 가지고 있니?</h1>
            {:else if $store.locale === 'vn'}
                <h1 class="question font-koho">Bạn có sở hữu Konnect NFT không?</h1>
            {:else}
                <h1 class="question font-koho">Do you own any NFTs?</h1>
            {/if}            
        </Typewriter>
    </Section>

    <Section
        name="home33"
        styles={sections[$store.type][$store.locale]['home33'] || null}
    >
        
        {#if $store.locale === 'en'}
            <div class="common-desc text-center">
                In the near future, this question will be asked as if it were a greeting.
                The world in more demand for NFT ownerships is coming faster than we think.
                Meet the NFT connected to Konnect in a world where individual rights are guaranteed 
                through decentralization and the Web3 ecosystem.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="common-desc text-center">
                인사처럼 물어볼 이 질문이, 이제 곧 다가올 우리의 모습입니다.
                더 많은 사람들이 NFT를 원하고 소유하려는 세상이 우리의 생각보다 더 빨리 다가오고 있습니다.
                탈중앙화와 웹3 생태계를 통해 개인의 권리가 보장받는 세상에서 Konnect와 연결된 NFT를 만나보세요.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="common-desc text-center">
                Nếu hệ sinh thái Konnect được hình thành, nó sẽ trở thành câu cửa miệng trong thời đại sắp tới. 
                Khi giá trị của NFT tăng lên, nhiều người sẽ muốn sở hữu nó hơn và thế giới mà người ta ghen tị 
                với những người có NFT sẽ đến sớm hơn chúng ta nghĩ.
                Konnect kết nối chúng ta với NFT thông qua KCT token được mã hóa và phân quyền hóa, giúp bảo vệ quyền cá nhân.
            </div>
        {/if}  
    </Section>
    
    <Section
        name="home34"
        styles={sections[$store.type][$store.locale]['home34'] || null}
    >
        <Typewriter cascade loop={true} interval={50} cursor={false}>
            <h1 class="slogan font-koho">NFT MARKETPLACE</h1>
        </Typewriter>
    </Section>

    <Section
        name="home35"
        styles={sections[$store.type][$store.locale]['home35'] || null}
    >        
        {#if $store.locale === 'en'}
            <div class="nft-title"># Mystery Box</div>
        {:else if $store.locale === 'kr'}
            <div class="nft-title"># 미스테리 박스</div>
        {:else if $store.locale === 'vn'}
            <div class="nft-title"># Mystery Box</div>
        {/if}  
    </Section>

    <Section
        name="home36"
        styles={sections[$store.type][$store.locale]['home36'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="common-desc">The mystery box is a gift from the Konnect World. Each box is classified by their tier and a corresponding high-end brand product is randomly assigned to it. Users can choose to claim the physical asset tied to the NFT.</div>
        {:else if $store.locale === 'kr'}
            <div class="common-desc">미스테리 박스는 DUMAN이 갖고 온 Konnect World의 선물입니다. 각 상자에는 등급이 있으며 등급에 따른 확률을 기반으로 명품 브랜드 제품이 나옵니다. 이렇게 나온 제품은 가상현실에서 뿐만 아니라 실물제품도 받을 수 있습니다.</div>
        {:else if $store.locale === 'vn'}
            <div class="common-desc">Những chiếc hộp bí ẩn từ Konnect World là những món quà đến từ DUMAN. Mystery Box được phân loại và chứa các sản phẩm thương hiệu sang trọng tương ứng với cấp bậc. Sản phẩm này không chỉ tồn tại trong metaverse mà cũng tồn tại trong thực tế để bạn có thể trao đổi.</div>

        {/if} 
    </Section>

    <Section
        name="home37"
        styles={sections[$store.type][$store.locale]['home37'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 700, height: 100 }
                : $store.locale === "kr"
                ? { width: 600, height: 100 }
                : $store.locale === "vn"
                ? { width: 600, height: 100 }
                : null}
            hide={false}
            onClick={() => alert("See you soon!")}
            text= {
                $store.locale === 'en' ? "Buy Mystery Box" 
                : $store.locale === 'kr' ? "미스테리 박스 사러가기"
                : $store.locale === 'vn' ? "Mua Mystery Box"  : "Buy Mystery Box"}
            cursor={true}
            typewriter={false}
            logo={true}
        />
    </Section>

    <Section
        name="home38"
        styles={sections[$store.type][$store.locale]['home38'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="nft-title"># DUMAN</div>
        {:else if $store.locale === 'kr'}
            <div class="nft-title"># 듀먼(DUMAN)</div>
        {:else if $store.locale === 'vn'}
            <div class="nft-title"># DUMAN</div>
        {/if} 
    </Section>

    <Section
        name="home39"
        styles={sections[$store.type][$store.locale]['home39'] || null}
    >            
        {#if $store.locale === 'en'}
            <div class="common-desc">
                DUMAN, the dominant species of Konnect World, has advanced intelligence under the influence of Konnect.
                They share the same culture as humans and have similar tastes.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="common-desc">
                Konnect World의 지배자 DUMAN은 Konnect 에너지를 흡수해 고차원적인 지능을 얻었습니다. 
                그들은 인간과 동일한 문화를 공유하고 즐긴 덕분에 현재 비슷한 취향을 가지고 있습니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="common-desc">
                DUMAN, người cai trị Konnect World, đã hấp thụ năng lượng Konnect và đạt được trí tuệ bậc cao. 
                Nhờ chia sẻ và tiếp thu nền văn hóa giống như con người nên hiện nay, họ có sở thích giống loài người.
            </div>
        {/if} 
    </Section>

    <Section
        name="home40"
        styles={sections[$store.type][$store.locale]['home40'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 650, height: 100 }
                : $store.locale === "kr"
                ? { width: 650, height: 100 }
                : $store.locale === "vn"
                ? { width: 650, height: 100 }
                : null}
            hide={false}
            onClick={() => alert("See you soon!")}
            text= {
                $store.locale === 'en' ? "Buy Duman NFT" : 
                $store.locale === 'kr' ? "듀먼 NFT 사러가기": 
                $store.locale === 'vn' ? "Mua Duman NFT" : 
                "Buy Duman NFT"
            }
            cursor={true}
            typewriter={false}
            logo={true}
        />
    </Section>

    <Section
        name="home41"
        styles={sections[$store.type][$store.locale]['home41'] || null}
    >
        <Typewriter cascade loop={true} interval={50} cursor={false}>
            <h1 class="slogan font-koho">E-COMMERCE</h1>
        </Typewriter>
    </Section>

    <Section
        name="home42"
        styles={sections[$store.type][$store.locale]['home42'] || null}
    >            
        {#if $store.locale === 'en'}
            <div class="common-desc">
                Konnect's infrastructure connects KCT users to the real economy.
                Not simply as a digital asset that only exists virtually and for investment purposes,
                Konnect and its partners prepare Konnect e-commerce with KCT tokens that can be utilized directly in the real economy.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="common-desc">
                Konnect의 인프라를 통해 KCT 사용자는 실물 경제와 연결됩니다. 
                지금까지 가상에만 존재하고 투자가치로만 존재하던 디지털자산이 아닌, 
                Konnect 파트너사를 통해 실물 경제에서 바로 사용가능한 KCT토큰을 활용한 Konnect 이커머스를 준비합니다. 
                Konnect는 더 빠른 실물 경제와의 연결을 위해 사용자와 함꼐 앞서 나갑니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="common-desc">
                KCT token cho phép người dùng kết nối nền kinh tế thật và cơ sở hạ tầng thật với hệ sinh thái Konnect.
                KCT token không phải là tài sản kỹ thuật số chỉ tồn tại trong thực tế ảo và chỉ có giá trị đầu tư, mà bạn có thể 
                sử dụng ngay lập tức trong nền kinh tế thật thông qua các đối tác của Konnect. Konnect sẽ cùng phát triển với người sử dụng để nhanh chóng hơn trong việc kết nối với nền kinh tế thật. 
            </div>
        {/if} 
    </Section>

    <Section
        name="home43"
        styles={sections[$store.type][$store.locale]['home43'] || null}
    >
        <div class="list-title">
            # 01
        </div>
        {#if $store.locale === 'en'}
            <div class="list-item font-roboto">
                Konnect Booking System 
                (Air, Accomodation, etc.)
                Discounts based on membership 
                and tier ratings
                in the Konnect e-commerce.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item font-roboto">
                커넥트 부킹 시스템
                (항공, 숙박 등)
                커넥트 이커머스 이용시 
                멤버십과 티어 등급에 
                따른 할인 혜택
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item font-roboto">
                Giảm giá và các quyền lợi bổ 
                sung tùy thuộc vào cấp độ thành 
                viên trong nền tảng E-commerce Konnect 
                (hàng hiệu, hàng không, khách sạn, v.v.)
            </div>
        {/if}
    </Section>

    <Section
        name="home44"
        styles={sections[$store.type][$store.locale]['home44'] || null}
    >
        <div class="list-title">
            # 02
        </div>
        {#if $store.locale === 'en'}
            <div class="list-item font-roboto">
                Discounts according to membership tier
                in the NFT Marketplace(Konnect World)
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item font-roboto">
                NFT Marketplace(Konnect World) 사용시 
                멤버십 등급에 따른 할인 혜택
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item font-roboto">
                Hơn 60.000 sản phẩm và dịch 
                vụ thông qua hơn 50 đối tác
            </div>
        {/if}
    </Section>

    <Section
        name="home45"
        styles={sections[$store.type][$store.locale]['home45'] || null}
    >
        <div class="list-title">
            # 03
        </div>
        {#if $store.locale === 'en'}
            <div class="list-item font-roboto">
                Membership and tier benefits
                according to KCT deposit
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item font-roboto">
                KCT 예치시 멤버십과 
                티어 등급 혜택 
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item font-roboto">
                Phát hành NFT được chứng nhận chính 
                hãng sau khi xác nhận mua hàng
            </div>
        {/if}
    </Section>

    <Section
        name="home46"
        styles={sections[$store.type][$store.locale]['home46'] || null}
    >
        <div class="list-title text-white">
            # 04
        </div>
        {#if $store.locale === 'en'}
            <div class="list-item font-roboto text-white">
                Limited NFT purchase and a chance for
                a mystery box purchase
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item font-roboto text-white">
                한정판 NFT 구매와
                미스터리 박스 구매 기회 
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item font-roboto text-white">
                Cung cấp dịch vụ giao dịch P2P bằng phương 
                thức NFT được chứng nhận trong tương lai
            </div>
        {/if}
    </Section>

    <Section
        name="home46-2"
        styles={sections[$store.type][$store.locale]['home46-2'] || null}
    >
        <div class="list-title text-white">
            # Brands we have
        </div>
    </Section>

    <Section
        name="home46-3"
        type="carousel"
        styles={sections[$store.type][$store.locale]['home46-3'] || null}
    >
        <div class="slogan font-koho text-center">KONNECT PARTNERS</div>
        {#if $store.locale === 'en'}
            <div class="common-desc text-center">We are creating a new world with diverse and powerful partners in the real economy.</div>
        {:else if $store.locale === 'kr'}
            <div class="common-desc text-center">우리는 실물경제의 다양하고 강력한 파트너들과 함께 새로운 세상을 만들어가고 있습니다.</div>
        {:else if $store.locale === 'vn'}
            <div class="common-desc text-center">Chúng tôi đang tạo ra một thế giới mới với những đối tác đa dạng và lớn mạnh trong nền kinh tế thật.</div>
        {/if}
    </Section>

    <Section
        name="home47"
        type="carousel"
        styles={sections[$store.type][$store.locale]['home47'] || null}
    >
        <BrandCarousel bind:carousel={brandCarousel} />
    </Section>

    <Section
        name="home48"
        type="carousel"
        styles={sections[$store.type][$store.locale]['home48'] || null}
    >
        <PartnersCarousel bind:carousel={partnersCarousel} />
    </Section>

    <Section
        name="home49"
        type="arrows"
        styles={sections[$store.type][$store.locale]['home49'] || null}
    >
        <i
            on:click={() => partnersCarousel.goToPrev()}
            class="bi bi-chevron-left partners-arrow"
        />

        <div class="d-inline-block" style={`width: ${$store.r * 150}px`} />

        <i
            on:click={() => partnersCarousel.goToNext()}
            class="bi bi-chevron-right partners-arrow"
        />
    </Section>

    <Section
        name="home49-2"
        type="carousel"
        styles={sections[$store.type][$store.locale]['home49-2'] || null}
    >
        <div class="slogan font-koho text-center">KCT ALLOCATION</div>
        {#if $store.locale === 'en'}
            <div class="common-desc text-center">KCT tokens are most effectively allocated according to our roadmap and economy that follows.</div>
        {:else if $store.locale === 'kr'}
            <div class="common-desc text-center">로드맵 및 토큰 경제에 따라 가장 효과적으로 KCT 토큰을 할당합니다.</div>
        {:else if $store.locale === 'vn'}
            <div class="common-desc text-center">Mã thông báo KCT được phân bổ hiệu quả nhất theo lộ trình và nền kinh tế của chúng tôi sau đó.</div>

        {/if}
    </Section>

    <!-- <Section
        name="home50"
        styles={sections[$store.type][$store.locale]['home50'] || null}
    >
        <div class="allocation-title">
            KCT ALLOCATION
        </div>
    </Section> -->

    <!-- <Section
        name="home51"
        styles={sections[$store.type][$store.locale]['home51'] || null}
    >
        
        {#if $store.locale === 'en'}
            <div class="common-desc">
                "KCT tokens are most effectively allocated according to our roadmap and evnomy that follows"
            </div>
        {:else if $store.locale === 'kr'}
            <div class="common-desc">
                "KCT 토큰은 로드맵과 할당 시스템에 따라 가장 효율적으로 할당됩니다"
            </div>
        {/if}
    </Section> -->

    <Section
        name="home52"
        styles={sections[$store.type][$store.locale]['home52'] || null}
    >
        <div class="roadmap-title">
            ROADMAP
        </div>
    </Section>
    

    <Section
        name="home53"
        type="arrows"
        styles={sections[$store.type][$store.locale]['home53'] || null}
    >
        <Roadmap />
    </Section>

    <Section
        id="contact" 
        name="home54"
        styles={sections[$store.type][$store.locale]['home54'] || null}
    >
        <div class="contact-title">
            CONTACT
        </div>
    </Section>

    <Section
        name="home55"
        styles={sections[$store.type][$store.locale]['home55'] || null}
    >
        <Contact />
    </Section>

    <Section
        name="home56"
        styles={sections[$store.type][$store.locale]['home56'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 500, height: 100 }
                : $store.locale === "kr"
                ? { width: 400, height: 100 }
                : $store.locale === "vn"
                ? { width: 400, height: 100 }
                : null}
            hide={false}
            cursor={false}
            typewriter={false}
            logo={true}
            onClick={async () => {
                if(emailSending) return;

                emailSending = true;

                var firstName = document.querySelector(
                    '#contact input[name=first-name]'
                ).value;
                var lastName = document.querySelector(
                    '#contact input[name=last-name]'
                ).value;
                var email = document.querySelector(
                    '#contact input[name=email]'
                ).value;
                var description = document.querySelector(
                    '#contact textarea[name=description]'
                ).value;

                if (!firstName) {
                    alert('Please input your first name');
                    document
                        .querySelector('#contact input[name=first-name]')
                        .focus();
                    return;
                }
                if (!lastName) {
                    alert('Please input your last name');
                    document
                        .querySelector('#contact input[name=last-name]')
                        .focus();
                    return;
                }
                if (!email) {
                    alert('Please input your email');
                    document
                        .querySelector('#contact input[name=email]')
                        .focus();
                    return;
                }
                if (!description) {
                    alert('Please input your description of your request');
                    document
                        .querySelector('#contact textarea[name=description]')
                        .focus();
                    return;
                }

                try {
                    let result = await emailjs.sendForm(
                            'service_5t8ch6n',
                            'template_bzbr5es',
                            '#contact',
                            'user_kNgC8L6EptFxkxNso9rjr'
                    )

                    if(result.text === 'OK') alert('Thanks for submitting :)')
                } catch(e) {
                    console.log(e.text);
                    alert('There is something wrong with the server :(')
                }

                emailSending = false;
            }}
            text= {$store.locale === 'en' ? "Submit" : $store.locale === 'kr' ? "보내기": "Submit"}
        />
    </Section>
</section>

<style>
    .slogan {
        margin: 0 !important;
        font-weight: 700;
        letter-spacing: -1px;
        font-size: 3vw;
    }

    .sub-slogan {
        font-size: 1.28vw;
        font-weight: 500;
        text-align: center;
    }

    .slogan2 {
        font-size: 3vw;
        text-align: center;
        color: white;
    }

    .slogan2 .accent {
        text-shadow: 0 0 3px #fff, 0 0 3px #fff, 0 0 3px #ffffff, 0 0 3px #ffffff, 0 0 3px #ffffff, 0 0 3px #ffffff, 0 0 3px #ffffff;
        font-weight: 800;
    }

    .slogan3 {
        font-family: koho;
        font-size: 3.1vw;
        text-align: center;
        color: #2d567a;
    }

    .about-title {
        color: #19195b;
        font-size: 2.3vw;
        font-weight: 500;
        letter-spacing: 0;
        font-family: roboto;
    }

    .about-desc {
        color: #616262;
        font-size: 1.2vw;
        text-align: center;
        line-height: 2.3vw;
        letter-spacing: -0.01vw;
        font-family: roboto;
        
        white-space: pre-line;
    }

    .nft-title {
        font-size: 2.015vw;
        font-family: roboto;
        font-weight: 500;
    }

    .common-title {
        font-size: 2.015vw;
        font-family: roboto;
        font-weight: 400;
        letter-spacing: -0.5px;
    }

    .allocation-title, .roadmap-title, .contact-title {
        font-size: 3.15vw;
        font-family: roboto;
        font-weight: 500;
        letter-spacing: -0.5px;
    }

    .common-title .highlight {
        font-size: 2.25vw;
        font-weight: bold;
        background-color: #f3d341;
    }

    .common-desc {
        font-size: 1.23vw;
        font-family: roboto;
        letter-spacing: -0.5px;
        line-height: 2.2vw;
        color: #6d6e6e;
        white-space: pre-line;
    }

    .membership-desc {
        line-height: 2.2vw;
    }

    .list-title {
        font-size: 2.2vw;
        font-weight: 500;
        font-family: roboto;
    }

    .list-item {
        white-space: pre-line;
        font-size: 1.3vw;
        /* letter-spacing: -2px; */
        font-family: roboto;
    }

    .story-title {
        font-weight: 400;
        font-size: 2vw;
        font-family: roboto;
    }

    .membership-title {
        font-size: 1.5vw;
        font-weight: 600;
        font-family: roboto;
    }

    .membership-title::before {
        width: 0.3vw;
        height: 1vw;
        margin-right: 0.4vw;
        content: '';
        background-color: #8dd7de;
        display: inline-block;
    }

    .membership-item {
        font-size: 3.3vw;
        font-weight: 600;
    }

    .story-item {
        white-space: pre-line;
        font-weight: 200;
        font-size: 1.2vw;
        line-height: 2.2vw;
        font-family: roboto;
    }

    .common-desc .title {

    }

    .question {
        font-size: 3.5vw;
        font-weight: 500;
        letter-spacing: -1px;
    }

    .partners-arrow {
        font-size: 5vw;
        margin-top: -2vw;
        cursor: pointer;
    }
</style>
